import React, { useEffect, useRef } from "react";
import { Button, Loading, Typography } from "@kitbird/core";
import {
  CardContent, PageCard, PageWrapper, TitleContent,
} from "../../../components/Content/Content.style";
import BBLogo from "../../../assets/icons/logogram_bb.png";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import SearchInput from "../../../components/SearchInput";
import { ActionSection } from "../../../components/Filter/Filter.style";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import Table from "../../../components/Table";
import columns from "./columns";
import { Provider, useTransactionCode } from "./hooks/Provider";
import { StickyTable } from "../../../components/Table/Table.style";
import TransactionCodeFormModal from "./components/TransactionCodeFormModal";
import TransactionCodeDeleteModal from "./components/TransactionCodeDeleteModal";
import PageLoading from "../../../components/Loading/PageLoading";
import FilterDropdown from "../../../components/FilterDropdown";

const TransactionCode = () => {
  const {
    meta,
    params,
    setParams,
    selectedEntryTypes,
    handleSelectEntryType,

    setModalConfig,
    transactionCodeQuery,
    transactionCodePages,
    searchText,
    setSearchText,
    isLoading,
  } = useTransactionCode();

  const {
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
  } = transactionCodeQuery;

  const obsRef = useRef(null);

  const options = {
    root: obsRef.current,
    rootMargin: "0px",
    threshold: [0],
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({
      isIntersecting,
    }) => {
      if (isIntersecting && !isFetching) {
        fetchNextPage();
      } else if (meta.page === meta.total_pages && !isFetching) {
        fetchNextPage();
      }
    });
  }, options);

  useEffect(() => {
    if (meta.page === meta.total_pages) observer.unobserve(obsRef.current || document.createElement("tfoot"));
    else observer.observe(obsRef.current || document.createElement("tfoot"));
  }, [meta]);

  return (<>
    <PageWrapper>
      <HeaderText>
        <Typography
          level={3}
          fontWeight="medium"
        >
          Master transaction code
        </Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <TitleContent>
            <img src={BBLogo} width={40} alt="" />
            <Typography level={4} fontWeight="medium">
              Daftar Transaction Code
            </Typography>
          </TitleContent>
          <ActionSection>
            <ActionSection style={{ justifyContent: "flex-start" }}>
              <SearchInput
                placeholder="Akun GL atau deskripsi"
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
              <FilterDropdown
                id="entry_type"
                options={selectedEntryTypes}
                label="Debit/kredit"
                multi
                width="200px"
                onSelected={handleSelectEntryType}
              />
            </ActionSection>
            <Button
              leftIcon={<PlusIcon />}
              onClick={() => setModalConfig({ type: "CREATE" })}
            >Tambah data</Button>
          </ActionSection>
          {(isFetching && !isFetchingNextPage)
            ? <Loading variant="line" />
            : <StickyTable>
              <Table
                withNumber
                columns={columns({ setModalConfig })}
                dataSource={transactionCodePages?.pages.flatMap((page) => page) || []}
                sortConfig={{
                  sortType: params.sortType,
                  sortBy: params.sortBy,
                  onSort: (name, type) => setParams(
                    (curr) => ({ ...curr, sortBy: name, sortType: type }),
                  ),
                }}
                footer={
                  <>
                    {(!isFetching && meta.page < meta.total_pages) && <tfoot ref={obsRef} style={{ height: 5, width: "100%" }} />}
                    {isFetchingNextPage && <Loading variant="circular" />}
                  </>
                }
              />
            </StickyTable>
          }
        </CardContent>
      </PageCard>
    </PageWrapper>
    {isLoading && (
      <PageLoading />
    )}
  </>);
};

const TransactionCodeWithProvider = () => (
  <Provider>
    <TransactionCode />
    <TransactionCodeFormModal />
    <TransactionCodeDeleteModal />
  </Provider>
);

export default TransactionCodeWithProvider;
